var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ec6321;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.501 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.582,24.625A29.125,29.125,0,0,0,21.325,24a3.309,3.309,0,0,1-1.506-.694,11.429,11.429,0,0,1-.106-2.95.648.648,0,0,1,.069-.237,9.224,9.224,0,0,0,.644-1.25,14.186,14.186,0,0,0,.475-2.081.486.486,0,0,1,.25-.35,1.138,1.138,0,0,0,.488-.838,8.855,8.855,0,0,0,.463-2.094.884.884,0,0,0-.2-.594.472.472,0,0,1-.125-.463A13.179,13.179,0,0,0,22.1,9.6c.056-2.569-1.956-5.1-5.594-5.1-3.694,0-5.656,2.531-5.6,5.1a13.746,13.746,0,0,0,.319,2.85.5.5,0,0,1-.125.463.853.853,0,0,0-.2.594,8.855,8.855,0,0,0,.463,2.094,1.152,1.152,0,0,0,.488.838.5.5,0,0,1,.25.35,14.186,14.186,0,0,0,.475,2.081,9.579,9.579,0,0,0,.644,1.25.44.44,0,0,1,.069.237,11.416,11.416,0,0,1-.106,2.95A3.309,3.309,0,0,1,11.675,24a29.126,29.126,0,0,0-3.256.625c-.888.312-3.456,1.281-3.906,3.269a.5.5,0,0,0,.494.606H28a.5.5,0,0,0,.488-.606C28.038,25.906,25.469,24.938,24.582,24.625Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.055,20.327H28.38V18.651A.651.651,0,0,0,27.728,18h0a.651.651,0,0,0-.651.651v1.675H25.4a.651.651,0,0,0-.651.651h0a.651.651,0,0,0,.651.651h1.675V23.3a.651.651,0,0,0,.651.651h0a.651.651,0,0,0,.651-.651V21.63h1.675a.651.651,0,0,0,.651-.651h0A.651.651,0,0,0,30.055,20.327Z",
    transform: "translate(-2.206 -1.471)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUser);
export default __webpack_public_path__ + "static/media/inviteUser.4ed22dae620181d51fb241a2ff711ba7.svg";
export { ForwardRef as ReactComponent };